



export class ZmienHasloModel {
    kod: string;
    noweHaslo: string;
}